/* FNDRY — social posts
   Plain JS, no framework. Init on DOMContentLoaded, re-init on
   shopify:section:load, guarded by a data-*-ready flag so editor re-renders
   never double-bind. */
(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  var LEAVE = 460;

  function reducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function Social(root) {
    this.root = root;
    this.rail = root.querySelector('[data-fsp-rail]');
    this.bar = root.querySelector('[data-fsp-bar]');
    this.barThumb = root.querySelector('[data-fsp-bar-thumb]');
    this.modal = root.querySelector('[data-fsp-modal]');
    this.dialog = root.querySelector('[data-fsp-dialog]');
    this.scrim = root.querySelector('[data-fsp-scrim]');
    this.closeBtn = root.querySelector('[data-fsp-close]');
    this.cards = Array.prototype.slice.call(
      root.querySelectorAll('[data-fsp-open]')
    );
    this.panels = Array.prototype.slice.call(
      root.querySelectorAll('[data-fsp-panel]')
    );

    this.index = 0;
    this.trigger = null;
    this.leaveTimer = null;
    this.closeTimer = null;

    // One media query, negated. Never its hand-written complement.
    this.mq = window.matchMedia('(min-width: 750px)');

    this.bind();
    this.measure();
  }

  Social.prototype.isMobile = function () {
    return !this.mq.matches;
  };

  /* ------------------------------------------------------------- binding */

  Social.prototype.bind = function () {
    var self = this;

    this.cards.forEach(function (card) {
      card.addEventListener('click', function () {
        self.open(parseInt(card.getAttribute('data-fsp-open'), 10) || 0, card);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', function () {
        self.close();
      });
    }

    if (this.scrim) {
      this.scrim.addEventListener('click', function () {
        self.close();
      });
    }

    this.panels.forEach(function (panel, i) {
      var prev = panel.querySelector('[data-fsp-prev]');
      var next = panel.querySelector('[data-fsp-next]');

      if (prev) {
        prev.addEventListener('click', function () {
          self.goTo(i - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          self.goTo(i + 1);
        });
      }

      panel.addEventListener('animationend', function (e) {
        if (e.target && e.target.classList) {
          e.target.classList.remove('is-pulsing');
        }
      });
    });

    this.onKey = function (e) {
      self.handleKey(e);
    };
    document.addEventListener('keydown', this.onKey);

    if (this.rail) {
      this.onScroll = function () {
        self.updateBar();
      };
      this.rail.addEventListener('scroll', this.onScroll, { passive: true });
    }

    /* P15 sitewide 2026-10-23: a resize that keeps the width is the phone
       toolbar collapsing or coming back - nothing here depends on height. */
    this.vw = document.documentElement.clientWidth;
    this.onResize = function () {
      if (self.resizeFrame) return;
      self.resizeFrame = window.requestAnimationFrame(function () {
        self.resizeFrame = 0;
        var w = document.documentElement.clientWidth;
        if (w === self.vw) return;
        self.vw = w;
        self.measure();
      });
    };
    window.addEventListener('resize', this.onResize);

    if (this.mq.addEventListener) {
      this.onMq = function () {
        self.measure();
      };
      this.mq.addEventListener('change', this.onMq);
    }
  };

  /* --------------------------------------------------- scroll indicator */

  Social.prototype.measure = function () {
    if (!this.rail || !this.bar || !this.barThumb) return;

    if (!this.isMobile()) {
      this.bar.hidden = true;
      return;
    }

    var items = this.rail.children;
    var count = items.length;
    if (!count) {
      this.bar.hidden = true;
      return;
    }

    var max = this.rail.scrollWidth - this.rail.clientWidth;
    if (max <= 1) {
      this.bar.hidden = true;
      return;
    }
    this.bar.hidden = false;

    var first = items[0].getBoundingClientRect();
    var stride = first.width;
    if (count > 1) {
      stride = items[1].getBoundingClientRect().left - first.left;
    }
    var perPage = stride > 0 ? Math.round(this.rail.clientWidth / stride) : 1;
    if (perPage < 1) perPage = 1;

    var pages = Math.ceil(count / perPage);
    if (pages < 1) pages = 1;

    this.barThumb.style.width = 100 / pages + '%';
    this.updateBar();
  };

  Social.prototype.updateBar = function () {
    if (!this.rail || !this.bar || !this.barThumb || this.bar.hidden) return;

    var max = this.rail.scrollWidth - this.rail.clientWidth;
    if (max <= 1) return;

    var track = this.bar.clientWidth;
    var thumb = this.barThumb.offsetWidth;
    var x = (this.rail.scrollLeft / max) * (track - thumb);

    if (x < 0) x = 0;
    if (x > track - thumb) x = track - thumb;

    this.barThumb.style.transform = 'translateX(' + x + 'px)';
  };

  /* ---------------------------------------------------------- the modal */

  Social.prototype.setActive = function (i) {
    var self = this;
    clearTimeout(this.leaveTimer);

    this.panels.forEach(function (panel, n) {
      panel.classList.remove('is-leaving', 'is-entering');
      if (n === i) {
        panel.hidden = false;
        panel.removeAttribute('aria-hidden');
        if ('inert' in panel) panel.inert = false;
        panel.scrollTop = 0;
      } else {
        panel.hidden = true;
        if ('inert' in panel) panel.inert = true;
      }
    });

    this.index = i;
    void self.root.offsetHeight;
  };

  Social.prototype.open = function (i, trigger) {
    if (!this.modal || !this.panels.length) return;
    if (i < 0 || i >= this.panels.length) i = 0;

    this.trigger = trigger || null;
    clearTimeout(this.closeTimer);

    this.modal.hidden = false;
    this.setActive(i);
    document.body.classList.add('fndry-no-scroll');

    var self = this;
    requestAnimationFrame(function () {
      self.modal.classList.add('is-open');
      var target = self.closeBtn || self.dialog;
      if (target) target.focus({ preventScroll: true });
    });
  };

  Social.prototype.close = function () {
    if (!this.modal || this.modal.hidden) return;

    var self = this;
    this.modal.classList.remove('is-open');
    document.body.classList.remove('fndry-no-scroll');

    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(
      function () {
        self.modal.hidden = true;
      },
      reducedMotion() ? 0 : 420
    );

    if (this.trigger && document.contains(this.trigger)) {
      this.trigger.focus({ preventScroll: true });
    }
  };

  Social.prototype.goTo = function (i) {
    if (!this.panels.length) return;
    if (i < 0 || i >= this.panels.length || i === this.index) return;

    var self = this;
    var cur = this.panels[this.index];
    var next = this.panels[i];

    clearTimeout(this.leaveTimer);

    // Anything still mid-swap from a fast double-click is retired now.
    this.panels.forEach(function (panel) {
      if (panel !== cur && panel !== next) {
        panel.hidden = true;
        panel.classList.remove('is-leaving', 'is-entering');
        if ('inert' in panel) panel.inert = true;
      }
    });

    cur.classList.remove('is-entering');
    cur.classList.add('is-leaving');
    cur.setAttribute('aria-hidden', 'true');
    if ('inert' in cur) cur.inert = true;

    next.hidden = false;
    next.classList.remove('is-leaving');
    next.classList.add('is-entering');
    next.removeAttribute('aria-hidden');
    if ('inert' in next) next.inert = false;
    next.scrollTop = 0;

    void next.offsetHeight;
    requestAnimationFrame(function () {
      next.classList.remove('is-entering');
    });

    this.index = i;

    this.leaveTimer = setTimeout(
      function () {
        cur.hidden = true;
        cur.classList.remove('is-leaving');
      },
      reducedMotion() ? 0 : LEAVE
    );

    this.pulse();

    // Keep focus inside the dialog after the panel it lived in goes away.
    if (this.dialog && this.dialog.contains(document.activeElement)) {
      var live = next.querySelector('[data-fsp-next]:not([disabled])');
      if (!live) live = next.querySelector('[data-fsp-prev]:not([disabled])');
      if (!live) live = this.closeBtn;
      if (live) live.focus({ preventScroll: true });
    }

    if (this.rail && this.cards[i]) {
      this.centreCard(i);
    }
  };

  Social.prototype.pulse = function () {
    if (!this.isMobile() || reducedMotion()) return;

    var btns = this.panels[this.index].querySelectorAll(
      '.fndry-social__nav-btn'
    );
    Array.prototype.forEach.call(btns, function (btn) {
      btn.classList.remove('is-pulsing');
      void btn.offsetWidth;
      btn.classList.add('is-pulsing');
    });
  };

  Social.prototype.centreCard = function (i) {
    if (!this.rail || !this.isMobile()) return;

    var card = this.cards[i];
    if (!card) return;

    var railBox = this.rail.getBoundingClientRect();
    var cardBox = card.getBoundingClientRect();
    var delta =
      cardBox.left - railBox.left - (railBox.width - cardBox.width) / 2;
    var left = this.rail.scrollLeft + delta;
    var max = this.rail.scrollWidth - this.rail.clientWidth;

    if (left < 0) left = 0;
    if (left > max) left = max;

    this.rail.scrollTo({
      left: left,
      behavior: reducedMotion() ? 'auto' : 'smooth'
    });
  };

  /* -------------------------------------------------------------- keys */

  Social.prototype.handleKey = function (e) {
    if (!this.modal || this.modal.hidden) return;

    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      this.close();
      return;
    }

    if (e.key === 'ArrowRight') {
      e.preventDefault();
      this.goTo(this.index + 1);
      return;
    }

    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      this.goTo(this.index - 1);
      return;
    }

    if (e.key !== 'Tab' || !this.dialog) return;

    var nodes = Array.prototype.filter.call(
      this.dialog.querySelectorAll(FOCUSABLE),
      function (el) {
        return el.offsetParent !== null && !el.closest('[aria-hidden="true"]');
      }
    );
    if (!nodes.length) return;

    var first = nodes[0];
    var last = nodes[nodes.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus({ preventScroll: true });
    }
  };

  /* ---------------------------------------------------------- teardown */

  Social.prototype.destroy = function () {
    document.removeEventListener('keydown', this.onKey);
    window.removeEventListener('resize', this.onResize);
    if (this.rail && this.onScroll) {
      this.rail.removeEventListener('scroll', this.onScroll);
    }
    if (this.mq.removeEventListener && this.onMq) {
      this.mq.removeEventListener('change', this.onMq);
    }
    document.body.classList.remove('fndry-no-scroll');
  };

  /* ------------------------------------------------------------- boot */

  var instances = [];

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-fndry-social]');

    Array.prototype.forEach.call(roots, function (root) {
      if (root.hasAttribute('data-fndry-social-ready')) return;
      root.setAttribute('data-fndry-social-ready', '');

      try {
        instances.push(new Social(root));
      } catch (err) {
        // Never let a thrown script leave the section holding content hidden.
        root.removeAttribute('data-fndry-social-ready');
        var hidden = root.querySelectorAll(
          '.fndry-social__badge, .fndry-social__stack'
        );
        Array.prototype.forEach.call(hidden, function (el) {
          el.style.opacity = '1';
          el.style.transform = 'none';
        });
        if (window.console && console.warn) {
          console.warn('fndry-social-posts:', err);
        }
      }
    });
  }

  function find(el) {
    var root = el && el.closest ? el.closest('[data-fndry-social]') : null;
    if (!root) return null;
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].root === root) return instances[i];
    }
    return null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    instances = instances.filter(function (inst) {
      if (e.target.contains(inst.root)) {
        inst.destroy();
        return false;
      }
      return true;
    });
  });

  document.addEventListener('shopify:block:select', function (e) {
    var inst = find(e.target);
    if (!inst) return;

    var card = e.target.matches('[data-fsp-open]')
      ? e.target
      : e.target.querySelector('[data-fsp-open]');
    if (!card) return;

    var i = parseInt(card.getAttribute('data-fsp-open'), 10) || 0;
    inst.open(i, card);
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var inst = find(e.target);
    if (inst) inst.close();
  });
})();